export const LOAD_PRODUCT = '[Products] LOAD_PRODUCT';
export const LOAD_PRODUCT_SUCCESS = '[Products] LOAD_PRODUCT_SUCCESS';
export const LOAD_PRODUCT_ERROR = '[Products] LOAD_PRODUCT_ERROR';

export const loadProductsAction = () => ({ type: LOAD_PRODUCT });
